<nav class="flex p-2 border border-[#e5e7eb] rounded-lg">
  <ng-content></ng-content>
</nav>
